import { useParams } from '@tanstack/react-router';

export function useWorkspaceId() {
  return useParams({ from: '/workspace/$workspaceId' }) as { workspaceId: string };
}
